import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PROP, TYPE, URL } from "../constant";
import { membersLearnersAPI } from "../api/entryExternal";
import { diagnosisProposalSelAPI } from "../api/diagnosisAPI";
import { gmEmailLoginAPI, learnerChoiceAPI } from "../api/accountAPI";
import { useLoading, useUserInfo, useLearningHistory, useAppAutoLogin, useAlert } from './';
import useStarShop from './useStarShop';
import { setActor, mathpidLogAPICall } from '../redux/logData';
import { setIOSAppId, getUserAgent } from '../utils/utilityEtc';

export default function useGmAppLogin() {
  const history = useHistory();
  const logDispatch = useDispatch();
  const [loginResult, setResult] = useState('');

  const [Alert] = useAlert();
  const { info, setInfo } = useUserInfo();
  const { starAuthAPICall } = useStarShop();
  const { setLoading, clearLoading } = useLoading();
  const { setLearningHistoryInfo } = useLearningHistory();
  const { appAutoLoginRegAPICall, appAutoLoginAPICall } = useAppAutoLogin();

  const handleLogin = async (pw, email) => {
    const isLoginChk = localStorage.getItem('mathpidLoginChk');
    setIOSAppId();
    setLoading({ isShowSpinner: true, spinnerType: '1' });
    try {
      let result = null;
      if (pw && email) {
        // 교문 이메일 로그인
        result = await gmEmailLoginAPI({
          chnCd: info.channelCode,
          emailAdrs: email,
          pw,
        });
        await localStorage.setItem("access.email", email);
      } else {
        result = await appAutoLoginAPICall();
      }
      if (!result) return;
      
      // 로그인 성공
      if (result.code === 'S000000') {
        let choiceLearner = '';
        let choiceMbrId = '';
        const { resp } = result;
        const { learner, sbsceMbrId, accessToken } = resp;

        await localStorage.setItem("access.token", accessToken);
        
        // 자동로그인 체크 시 APP 자동로그인 등록
        if (isLoginChk === 'Y' && pw && email) {
          appAutoLoginRegAPICall(sbsceMbrId, TYPE.CHANNEL.GM_APP);
        }

        if (learner.length > 1) {
          history.push({
            pathname: URL.ACCOUNT.LEARNER_CHOICE,
            state: {
              sbsceMbrId,
              email,
              learner
            }
          })
        } else {

          if (learner && learner.length === 0) {
            Alert("가입된 자녀가 없습니다.");
          }

          choiceLearner = learner[0].cstmrNo;

          // 학습자 1명일 때 학습자 선택
          const learnResp = await learnerChoiceAPI({
            sbsceMbrId,
            cstmrNo: learner[0].cstmrNo,
            contract: learner[0].cntrtNo,
          });
          starAuthAPICall(learner[0].cntrtNo);
          // 특정학습회원 조회
          const memberResp = await membersLearnersAPI(sbsceMbrId, learnResp.lrnMbrId);
          const { brthmt, sxdnCd, mbrNm, mbrId, emailAdrs } = memberResp;

          choiceMbrId = mbrId;
          // 테스트 자동 로그인 하고 싶을 때
          // localStorage.setItem("learner.id", learnResp.lrnMbrId);

          setInfo({
            userId: sbsceMbrId,
            cntrtNo: learner[0].cntrtNo,
            learnerCode: learner[0].cstmrNo,
            userEmail: emailAdrs ? emailAdrs : localStorage.getItem("access.email"),
            locale: 'KO',
            learnerId: mbrId,
            learnerBirth: brthmt,
            learnerSex: sxdnCd,
            learnerName: mbrNm,
            iconImage: PROP.SIDE_ICON[0],
            learner
          });

          const diagnosisInfo = await diagnosisProposalSelAPI(learnResp.lrnMbrId);

          if (diagnosisInfo) {
            const { dgnsRsltCnfmYn, dgnsYn, memberYn } = diagnosisInfo;
            setInfo({
              isMember: memberYn,
            });

            setLearningHistoryInfo({
              isCompleteAIDiagnosis: dgnsYn,
              isCheckAIDiagnosisResult: dgnsRsltCnfmYn,
            })
          };

          history.push(URL.SELECT_LEARNING);
        }

        logDispatch(setActor({
          account: {
            homePage: TYPE.ENTRY_TYPE.GM_APP,
            name: choiceMbrId
          },
          name: choiceLearner,
          objectType: "Agent"
        }));

        setTimeout(() => {
          // 앱 최초 진입시 호출
          logDispatch(mathpidLogAPICall({
            verbId: 'focused',
            objectId: 'application',
            idName: getUserAgent('packageName'),
            idValue: getUserAgent('VERSION_NAME')
          }));
        }, 0);


        // logDispatch(setUserInfo({
        //   userType: 'USER',
        //   ssaid: await getAppId()
        // }));

      } else {
        setResult('fail');
      }
    } catch (error) {
      console.log("##### error handleLogin: ", error);
    } finally {
      clearLoading();
    }
  }

  return [handleLogin, loginResult]
}